import toastr from "toastr";
import * as domainConstants from "../constants/DomainConstants";
import * as toastrMessages from "../constants/ToastrConstants";

let toastrOptions = {
    showMethod: 'slideDown',
    positionClass: 'toast-bottom-right'
};

export function showToastrSuccess(message) {
    toastr.options = toastrOptions;
    toastr.success(message);
}

export function showToastrError(message) {
    toastr.options = toastrOptions;
    toastr.error(message);
}

export function showToastrInfo(message) {
    toastr.options = toastrOptions;
    toastr.info(message);
}

export default function showToastr(notification) {

    toastr.options = toastrOptions;

    switch (notification) {
        case domainConstants.SUCCESS:
            toastr.success(toastrMessages.MESSAGE_SAVED, toastrMessages.TITLE_SUCCESS);
            return true;

        case domainConstants.SUCCESS_NO_TOASTR:
            return true; // is saved...

        case domainConstants.HAS_CONCURRENCY_EXCEPTION:
            toastr.error(toastrMessages.MESSAGE_NOT_SAVED_CONCURRENCY_EXCEPTION, toastrMessages.TITLE_ERROR);
            return false; // is not saved

        case domainConstants.HAS_VALIDATION_ERRORS:
            toastr.error(toastrMessages.MESSAGE_VALIDATION_ERRORS, toastrMessages.TITLE_ERROR);
            return false; // is not saved

        case domainConstants.HAS_VALIDATION_ERRORS_SAVED:
            toastr.success(toastrMessages.MESSAGE_SAVED, toastrMessages.TITLE_SUCCESS);
            toastr.warning(toastrMessages.MESSAGE_VALIDATION_ERRORS_SAVED, toastrMessages.TITLE_WARNING);
            return true; // is saved

        case domainConstants.HAS_FILE_EXCEPTION:
            toastr.error(toastrMessages.MESSAGE_FILE_EXCEPTION, toastrMessages.TITLE_ERROR);
            return false; // is not saved

        case domainConstants.NO_GEOCOORDINATEN_FOUND:
            toastr.warning(toastrMessages.MESSAGE_NO_GEOCOORDINATEN, toastrMessages.TITLE_WARNING); //refactor to use toastrMessages
            return false;
        case domainConstants.NO_GEOCOORDINATEN_FOUND2:
            toastr.warning(toastrMessages.MESSAGE_NO_GEOCOORDINATEN2, toastrMessages.TITLE_WARNING);
            return false;
        case domainConstants.RAPPORT_GENEREREN:
            toastr.info(toastrMessages.MESSAGE_RAPPORT_GENEREREN, toastrMessages.TITLE_INFO);
            return true;
        case domainConstants.PDF_SIMULATIE_GENEREREN:
            toastr.info(toastrMessages.MESSAGE_RAPPORT_SIMULATIE_GENEREREN, toastrMessages.TITLE_INFO);
            return true;
        case domainConstants.PDF_GENEREREN:
            toastr.info(toastrMessages.MESSAGE_PDF_GENEREREN, toastrMessages.TITLE_INFO);
            return true;

        case domainConstants.HAS_VALIDATION_ERRORS_SAVED_SIMULATIE:
            toastr.success(toastrMessages.MESSAGE_SAVED, toastrMessages.TITLE_SUCCESS);
            toastr.warning(toastrMessages.MESSAGE_VALIDATION_ERRORS_SAVED_SIMULATIE, toastrMessages.TITLE_WARNING);
            return true; // is saved
    }
}